import type { ReactNode } from 'react';
import { RefreshCw } from 'lucide-react';
import { Badge } from '@/components/ui/misc';
import { cn } from '@/lib/utils';

/**
 * Selo de mesa espelhada do TiFlux (spec 011). O texto diz o que fazer, não só
 * o estado: quem cai aqui quer editar, e a edição mora no TiFlux.
 */
export function MirroredBadge({
  label = 'Espelhado do TiFlux — edite no TiFlux',
  className,
}: {
  label?: string;
  className?: string;
}) {
  return (
    <Badge
      variant="info"
      className={className}
      title="O ERP atualiza este conteúdo a partir do TiFlux a cada sincronização"
    >
      <RefreshCw className="size-3" />
      {label}
    </Badge>
  );
}

/**
 * No lugar de um bloco de edição (comentário, apontamento…) em ticket
 * espelhado: explica por que o controle não está ali, em vez de sumir calado.
 */
export function MirroredNotice({
  children,
  className,
}: {
  children: ReactNode;
  className?: string;
}) {
  return (
    <div
      className={cn(
        'flex items-start gap-2 rounded-lg border border-[#91CAFF] bg-[#E6F4FF] p-4 text-sm text-[#0958D9]',
        className
      )}
    >
      <RefreshCw className="mt-0.5 size-4 shrink-0" />
      <p>{children}</p>
    </div>
  );
}
